import {
	Card,
	CardHeader,
	CardBody,
	Flex,
	HStack,
	Text,
	VStack,
	Box,
} from '@chakra-ui/react'
import ButtonCTA from '../globalComponents/button'
import PropTypes from 'prop-types'
import SVGIcon from '../../assets/svgIcons'

const WhatNextCommonUI = ({
	headerText,
	bodyContent,
	buttonsList,
	children,
}) => {
	return (
		<Box w='60%' padding='0.5rem 1rem'>
			<Card bg='blue.600' color='white'>
				<CardHeader pb='0' pl='1rem'>
					<Flex gap='1rem' alignItems='center'>
						<SVGIcon
							iconName='GreneSmallLogoSvg'
							svgProps={{ width: '36', height: '10', viewBox: '0 0 36 10' }}
							pathProps={{ fill: 'white' }}
						/>{' '}
						<Text fontWeight='500' fontSize='1rem'>
							{headerText}
						</Text>
					</Flex>
				</CardHeader>
				<CardBody pt='1rem' pl='1rem'>
					{bodyContent}
				</CardBody>
			</Card>

			<HStack justifyContent={'flex-end'}>
				<VStack justifyContent={'flex-end'} alignItems={'flex-end'} mt='0.5rem'>
					{buttonsList?.map(button => (
						<ButtonCTA
							variant='whatsNextButton'
							onClick={button.action}
							isLoading={button?.isLoading}
						>
							{button.label}
						</ButtonCTA>
					))}
				</VStack>
			</HStack>
			{children}
		</Box>
	)
}

WhatNextCommonUI.propTypes = {
	headerText: PropTypes.string.isRequired,
	bodyContent: PropTypes.element,
	buttonsList: PropTypes.array.isRequired,
}

export { WhatNextCommonUI }
